document.addEventListener('DOMContentLoaded', function() {
  // Override the getImageData method in theme.Photoswipe to filter out video slides
  const originalPhotoswipe = theme.Photoswipe.prototype.getImageData;
  
  if (originalPhotoswipe) {
    theme.Photoswipe.prototype.getImageData = function() {
      // Call the original method to get all items
      const allItems = originalPhotoswipe.apply(this, arguments);
      
      // Filter out items that are videos
      return allItems.filter(function(item) {
        // Check if the element is a video
        const el = item.el;
        const parentEl = el.closest('.product-main-slide');
        
        // If parent slide has a video element or video wrapper, exclude it
        if (parentEl) {
          const hasVideo = 
            parentEl.querySelector('.product__video') || 
            parentEl.querySelector('.product__video-wrapper') ||
            parentEl.querySelector('[data-video-type]');
          
          return !hasVideo;
        }
        
        return true;
      });
    };
  }
});